import React, { useEffect, useState } from 'react'
import Tabs from '../common/Tabs'
import TabContent from '../../../partials/TabsContainer/TabContent.js'
import "./Interference.scss"

const Interference = (props) => {

    const { data, onComplete } = props
    const [ view, setView ] = useState()

    useEffect(() => {

        if(!view) setView('tabs')                                                  
        
    }, []) 

    return (
        <div className="interference-container">
            
            <div className="interference-body">
            { view === 'tabs' && <Tabs 
                                    tabsArray={data.tabs} 
                                    onComplete={onComplete}
                                    tabComponent={props => <div>{props.name}</div> } 
                                    tabContentComponent={TabContent} 
             /> }
            </div>
        </div>
    );
}

export default Interference